import _ from '@lodash';
import XAPPService from 'app/Core/services/XAPPService';
export const GET_JSON = '[PRIMEIROSPASSOS APP] GET JSON';
export const PRIMEIROSPASSOS_ERROR = '[PRIMEIROSPASSOS APP] PRIMEIROSPASSOS ERROR';
export const GET_CONTEUDO = '[PRIMEIROSPASSOS APP] GET CONTEUDO';
export const GET_DIALOG = '[PRIMEIROSPASSOS APP] GET DIALOG';

const GetState = [
    'idconteudo',
    'titulo',
    'descricao',
    'conteudo',
    'tipo',
    'grupo',
    'grupodescricao',
    'categoria',
    'categoriadescricao'
];

export function getJson(_AID, _AParams) {

    return (dispatch) => {

        var AConditionsAND = [{ Campo: "conteudo.idconteudo", Operador: "=", Valor: _AID }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "conteudos", AActions, "spvwconteudo", GetState, "SELECIONAR", AConditionsAND, AConditionsOR)

        XAPPService.XappRegisterAction(AActions, 'SEL')
            .then((response) => {
                if (response.data && response.data.length > 0 && !_.isNull(JSON.parse(response.data)[0].data) && JSON.parse(response.data)[0].data.length > 0) {
                    try {
                        var AConteudo = JSON.parse(JSON.parse(response.data)[0].data[0].conteudo)
                        AConteudo.idconteudo = JSON.parse(response.data)[0].data[0].idconteudo;
                    }
                    catch (error) {
                        return dispatch({
                            type: PRIMEIROSPASSOS_ERROR,
                            payload: "Erro ao parsear conteudo"
                        });
                    }
                    return dispatch({
                        type: GET_JSON,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: AConteudo,
                    });
                }
                else {
                    return dispatch({
                        type: PRIMEIROSPASSOS_ERROR,
                        payload: "Conteudo não encontrado"
                    });
                }
            })
            .catch(error => {
                return dispatch({
                    type: PRIMEIROSPASSOS_ERROR,
                    payload: error
                });
            });
    };
}

export function getConteudo(_AID, _AParams) {

    return (dispatch) => {

        var AConditionsAND = [{ Campo: "conteudo.idconteudo", Operador: "=", Valor: _AID }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "conteudos", AActions, "spvwconteudo", GetState, "SELECIONAR", AConditionsAND, AConditionsOR)

        XAPPService.XappRegisterAction(AActions, 'SEL')
            .then((response) => {
                if (response.data && response.data.length > 0 && !_.isNull(JSON.parse(response.data)[0].data) && JSON.parse(response.data)[0].data.length > 0) {
                    return dispatch({
                        type: GET_CONTEUDO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0].conteudo : ""
                    });
                }
            })
            .catch(error => {
                return dispatch({
                    type: PRIMEIROSPASSOS_ERROR,
                    payload: error
                });
            });
    };
}

export function getDialog(_AID, _AParams) {

    return (dispatch) => {

        var AConditionsAND = [{ Campo: "conteudo.idconteudo", Operador: "=", Valor: _AID }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "conteudos", AActions, "spvwconteudo", GetState, "SELECIONAR", AConditionsAND, AConditionsOR)

        XAPPService.XappRegisterAction(AActions, 'SEL')
            .then((response) => {
                return dispatch({
                    type: GET_DIALOG,
                    Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                    payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : ""
                });
            })
            .catch(error => {
                return dispatch({
                    type: PRIMEIROSPASSOS_ERROR,
                    payload: error
                });
            });
    };
}

export function closePainel() {
    return {
        type: GET_JSON,
        payload: null
    }
}

export function closeDialog() {
    return {
        type: GET_DIALOG,
        payload: null
    }
}